import { InjectionToken } from "@angular/core";

export interface PilotOperatorSearchEndpoints {
    getPilotOrOperator: string;
    getOperatorByLegacyHash: string;
    getPilotByLegacyHash: string;
}

export const PILOT_OPERATOR_SEARCH_API_TOKENS = new InjectionToken<PilotOperatorSearchEndpoints>("Pilot operator search endpoints token");
